import React, { useEffect, useState } from 'react';
import { Phone } from 'lucide-react';
const PHONE = '586-203-3701';
export function FloatingCall() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 400);
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <a href={`tel:${PHONE.replace(/-/g, '')}`} aria-label={`Call Moceri at ${PHONE}`} className={`hidden md:inline-flex fixed bottom-6 right-6 z-40 items-center gap-3 bg-[#2DB8E0] hover:bg-[#1a9cc4] text-white font-bold px-5 py-4 rounded-full shadow-2xl transition-all ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4 pointer-events-none'}`} data-id="element-91">
      <span className="relative flex h-3 w-3" data-id="element-92">
        <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-white opacity-75" data-id="element-93"></span>
        <span className="relative inline-flex rounded-full h-3 w-3 bg-white" data-id="element-94"></span>
      </span>
      <Phone className="w-5 h-5" data-id="element-95" />
      <span data-id="element-96">{PHONE}</span>
    </a>;
}